import { notification, Alert } from "antd";
// true maeans success and false means Error
const btn = null;
const openNotification = (msg: string, status: any) => {
  notification.open({
    message: <Alert message={msg} type={status} />,
    onClick: () => {
      console.log("Notification Clicked!");
    },
    style: {
      padding: 0,
    },
    btn,

    className: "custom-notif",
  });
};
export default openNotification;

notification.config({
  // placement: "bottomRight",
  bottom: 50,
  duration: 3,
  rtl: true,
});
